import React, { useState, useEffect } from "react";
import API_BASE_URL from "../config";
import ErrorScreen from "../components/ErrorScreen";
import { useUser } from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import AlertModal from "../components/AlertModal";
import { useAlertModal } from "../hooks/useAlertModal";

const GameManagement = () => {
  const [games, setGames] = useState([]);
  const [rooms, setRooms] = useState([]); // 방 목록
  const [roomData, setRoomData] = useState({
    sb: "",
    bb: "",
    ante: "",
    minbuyin: "",
    maxbuyin: "",
  });
  const [penaltySetting, setPenaltySetting] = useState({
    firstRange: "15",
    secondRange: "10",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);

  const { userInfo } = useUser();
  const navigate = useNavigate();
  const { isAlertOpen, alertMessage, showAlert, closeAlert } = useAlertModal();

  const [isRoomMiniTabOpen, setRoomMiniTabOpen] = useState(false);
  const [isPenaltyMiniTabOpen, setPenaltyMiniTabOpen] = useState(false);
  const [isCreateRoomOpen, setCreateRoomOpen] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/game-api/game`, {
          method: "POST",
          headers: {
            "X-Frontend-Request": "true",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: userInfo.username,
            page,
            size,
          }),
        });

        if (!response.ok) throw new Error("게임 목록을 불러오는 데 실패했습니다.");

        const data = await response.json();
        setGames(data.content || []);
        setTotalPages(data.totalPages || 0);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchGames();
  }, [page]);

   const fetchRooms = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/game-api/get-room`, {
      method: "GET",
      headers: {
        "X-Frontend-Request": "true",
        "Content-Type": "application/json",
      }
    });

    // ✅ 여기 누락됨: response.ok 체크
    if (!response.ok) throw new Error("게임 서버에서 방 목록을 불러오지 못했습니다.");

    const data = await response.json();
    setRooms(data.rooms);
 
    
  } finally {
    setLoading(false);
  }
};
  useEffect(() => {
   

   // fetchRooms();
  },[]);


  if (loading) return <div className="loading-overlay"><div className="loader"></div></div>;
  if (error) return <ErrorScreen message={error} />;

  const toggleActiveStatus = async (id) => {
    try {
      await fetch(`${API_BASE_URL}/game-api/${id}/toggle-status`, { method: "PATCH", headers: { "Content-Type": "application/json" } });
      setGames(prev => prev.map(g => g.id === id ? { ...g, active: !g.active } : g));
    } catch (err) {
      console.error(err);
    }
  };

  const openRoomList = async (game) => {
    try {
    await fetchRooms();
    setSelectedGame(game);
    setRoomMiniTabOpen(true);
  } catch (err) {
    console.error("방 목록 불러오기 실패:", err);
    showAlert("❌ 게임 서버 연결에 실패했습니다.");
  }
  };

  const closeMiniTab = () => {
    setRoomMiniTabOpen(false);
    setPenaltyMiniTabOpen(false);
    setSelectedGame(null);
    setCreateRoomOpen(false);
  };

  const handleCreateRoom = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/game-api/create-room`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          gameId: selectedGame?.id,
          sb: parseInt(roomData.sb),
          bb: parseInt(roomData.bb),
          ante: parseInt(roomData.ante),
          minbuyin: parseInt(roomData.minbuyin),
          maxbuyin: parseInt(roomData.maxbuyin),
        }),
      });
      if (!response.ok) throw new Error("방 생성 실패");

      showAlert("✅ 방이 생성되었습니다.");

      await new Promise((resolve) => setTimeout(resolve, 500));
      await fetchRooms();
    
      setRoomData({ sb: "",
    bb: "",
    ante: "",
    minbuyin: "",
    maxbuyin: ""});
      
      setCreateRoomOpen(false);

    } catch (err) {
      showAlert(err.message);
    }
  };

  const handleDeleteRoom = async (roomUID) => {
  try {
    const response = await fetch(`${API_BASE_URL}/game-api/delete-room`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ roomUID }),
    });

    const data = await response.json();

    if (!data.ok) {
      throw new Error(data.reason || "방 삭제 실패");
    }

    // 성공 시 삭제된 방 제거
    setRooms((prev) => prev.filter((room) => room.UID !== roomUID));
    showAlert("✅ 방이 삭제되었습니다.");
  } catch (err) {
    console.error(err);
    showAlert("❌ " + (err.message || "방 삭제 실패"));
  }
};

  const openHandoutPenaltyModal = (game) => {
    setSelectedGame(game);
    setPenaltyMiniTabOpen(true);
    setPenaltySetting({
      firstRange: game.penalty_low?.toString() ?? "15",
      secondRange: game.penalty_middle?.toString() ?? "10",
    });
  };

  const handleApplyPenalty = async () => {
    if (!selectedGame) return;
    try {
      const response = await fetch(`${API_BASE_URL}/game-api/penalty-setting`, {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-Frontend-Request": "true" },
        body: JSON.stringify({
          gameId: selectedGame.id,
          firstPenaltyPercent: parseFloat(penaltySetting.firstRange),
          secondPenaltyPercent: parseFloat(penaltySetting.secondRange),
        }),
      });
      if (!response.ok) throw new Error("패널티 설정에 실패했습니다.");
      setGames(prev => prev.map(g => g.id === selectedGame.id ? { ...g, penalty_low: parseFloat(penaltySetting.firstRange), penalty_middle: parseFloat(penaltySetting.secondRange) } : g));
      showAlert("✅ 페널티 설정이 정상적으로 저장되었습니다.");
      closeMiniTab();
    } catch (err) {
      showAlert(err.message || "오류가 발생했습니다.");
    }
  };

  return (
    <div className="container-inner">
      <h2>게임 관리</h2>

      {games.length > 0 ? (
        <>
          <div className="game-list">
            {games.map(game => (
              <div key={game.id} className="game-item">
                <div className="thumb">
                  <img src={`/assets/images/game_thumb${game.gameId}.png`} alt="게임 썸네일" />
                </div>
                <div className="contents">
                  <div className="game-title-row">
                    <p className="name">{game.gameType}</p>
                    <button className={`btn-toggle ${game.active ? "on" : "off"}`} onClick={() => toggleActiveStatus(game.id)}>
                      {game.active ? "ON" : "OFF"}
                    </button>
                  </div>
                  <p className="text">{game.gameDescription}</p>
                  <div className="game-code">
                    <div className="game-code-item">
                      <span className="game-code-label">관리자:</span>
                      <span className="game-code-value">{game.adminUserName}</span>
                    </div>
                    <div className="game-code-item">
                      <span className="game-code-label">게임 코드:</span>
                      <span className="game-code-value">{game.gameCode}</span>
                    </div>
                  </div>
                   {userInfo?.adminType === "어드민" && (
                      <div className="button-row">
                        <button className="btn-primary" onClick={() => openRoomList(game)}>방 목록</button>
                        <button className="btn-penalty" onClick={() => openHandoutPenaltyModal(game)}>핸드아웃 패널티 설정</button>
                      </div>
                    )}
                </div>
              </div>
            ))}
          </div>
          {/* 페이지네이션 */}
          <div className="pagination">
            <button disabled={page === 0} onClick={() => setPage(page - 1)}>◀</button>
            {Array.from({ length: totalPages }, (_, i) => (
              <button key={i} className={page === i ? "active" : ""} onClick={() => setPage(i)}>{i + 1}</button>
            ))}
            <button disabled={page === totalPages - 1} onClick={() => setPage(page + 1)}>▶</button>
          </div>
        </>
      ) : (
        <div className="empty-state">
          <i className="fa-solid fa-gamepad"></i>
          <p className="title">등록된 게임이 없습니다</p>
        </div>
      )}

     
    {isRoomMiniTabOpen && selectedGame && (
      <div className="room-mini-tab-overlay-independent" onClick={closeMiniTab}>
        <div
            className={`room-mini-tab-independent ${isCreateRoomOpen  ? "expanded" : ""}`}
          onClick={(e) => e.stopPropagation()} >
          {/* 상단: 방 목록 */}
         <div className="room-management-independent">
                          <div className="room-header-independent">
                            <h3>방 목록</h3>
                            <span className="current-game-independent">{selectedGame.gameType}</span>
                          </div>
                         
                <div className="room-list-wrapper">
                  {rooms.length > 0 ? (
                    rooms.map((room, index) => (
                     <div key={room.UID} className="room-card-minimal">
                          {/* 카드 상단: 이름 + 생성일 */}
                          <div className="room-card-top">
                            <span className="room-name">{room.RoomName}</span>
                            <span className="room-created">{new Date(room.CreateTime).toLocaleString()}</span>
                          </div>

                          {/* 카드 내용: Info 그룹 + Player */}
                          <div className="room-card-independent">
                            <div className="room-card-info">
                              <div className="info-item">
                                <i className="fa-solid fa-circle"></i>
                                <div className="info-text">
                                  <span className="label">SB</span>
                                  <span className="value">{room.BigBlind / 2}</span>
                                </div>
                              </div>
                              <div className="info-item">
                                <i className="fa-solid fa-circle"></i>
                                <div className="info-text">
                                  <span className="label">BB</span>
                                  <span className="value">{room.BigBlind}</span>
                                </div>
                              </div>
                              <div className="info-item">
                                <i className="fa-solid fa-circle"></i>
                                <div className="info-text">
                                  <span className="label">Ante</span>
                                  <span className="value">{room.MinBuyin / 10}</span>
                                </div>
                              </div>
                              <div className="info-item wide">
                                <i className="fa-solid fa-circle"></i>
                                <div className="info-text">
                                  <span className="label">Min/Max</span>
                                  <span className="value">{room.MinBuyin} / {room.MaxBuyin}</span>
                                </div>
                              </div>
                            </div>

                            <div className="room-card-players">
                              <i className="fa-solid fa-users"></i>
                              <span>{room.PlayerCount}/{room.MaxPlayers}</span>
                            </div>
                          </div>

                          {/* 카드 하단: 액션 */}
                          <div className="room-card-actions">
                            <button className="btn-delete-minimal" onClick={() => handleDeleteRoom(room.UID)}>삭제</button>
                          </div>
                        </div>
                    ))
                  ) : (
                <div className="room-empty-independent">
                  <div className="empty-icon-wrapper-independent">
                    <i className="fa-regular fa-building empty-icon-independent"></i>
                  </div>
                  <h2 className="empty-title-independent">등록된 방이 없습니다</h2>
                  <p className="empty-subtitle-independent">
                    아직 생성된 방이 없어요.<br />
                    새로운 방을 만들어보세요.
                  </p>
                </div>
              )}
            </div>
          </div>

        <div className="button-row-independent">
          <button
            className="btn-primary-independent"
            onClick={() => setCreateRoomOpen(true)}
          >
            방 생성
          </button>
          <button
            className="btn-primary-outline-independent"
            onClick={closeMiniTab}
          >
            닫기
          </button>
        </div>

        {/* 내부 팝업: 방 생성 */}
      <div
          className={`inner-room-tab-independent ${isCreateRoomOpen ? "show" : ""}`}
        >
           <h4 className="inner-tab-title">방 생성</h4>
          
         <div className="form-fields-wrapper">
            {["bb","sb","ante","minbuyin","maxbuyin"].map((field) => (
              <div className="form-item-modal" key={field}>
                <label>{field.toUpperCase()}</label>
                <input
                  type="number"
                  value={roomData[field]}
                  readOnly={field === "sb"}
                  disabled={field === "sb"}
                  onChange={(e) => {
                    const value = e.target.value;
                    setRoomData((prev) => ({
                      ...prev,
                      [field]: value,
                      ...(field === "bb" ? { sb: value * 0.5 } : {}),
                    }));
                  }}
                />
              </div>
            ))}
          </div>

          <div className="inner-buttons-independent">
            <button className="btn-primary-independent" onClick={handleCreateRoom}>
              생성
            </button>
            <button
              className="btn-primary-outline-independent"
              onClick={() => setCreateRoomOpen(false)}
            >
              닫기
            </button>
          </div>
        </div>
    </div>
    </div>
    )}

      {/* 핸드아웃 패널티 */}
      {isPenaltyMiniTabOpen && (
        <div className="mini-tab" onClick={(e) => e.stopPropagation()}>
          <div className="mini-tab-content">
            <h3>핸드아웃 패널티 설정</h3>
            <div className="penalty-contents">
              <div className="form-item-modal">
                <label>1~49판 ({penaltySetting.firstRange}%)</label>
                <input type="range" min="0" max="100" value={penaltySetting.firstRange} onChange={(e) => setPenaltySetting({ ...penaltySetting, firstRange: e.target.value })} className="styled-range" />
              </div>
              <div className="form-item-modal">
                <label>50~99판 ({penaltySetting.secondRange}%)</label>
                <input type="range" min="0" max="100" value={penaltySetting.secondRange} onChange={(e) => setPenaltySetting({ ...penaltySetting, secondRange: e.target.value })} className="styled-range" />
              </div>
              <button className="btn-primary" onClick={handleApplyPenalty}>적용</button>
              <button className="btn-primary-outline" onClick={closeMiniTab}>닫기</button>
            </div>
          </div>
        </div>
      )}

      {isAlertOpen && <AlertModal message={alertMessage} onClose={closeAlert} />}
    </div>
  );
};

export default GameManagement;